import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-timer-flash-line"></i>
            <span>最新动态</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            糖心视频平台功能与内容的最新更新动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-5 md:left-6 top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updateItems.map((item) => (
              <a
                key={item.id}
                href={item.url}
                className="relative flex items-start gap-4 md:gap-6 pl-0 group cursor-pointer"
              >
                <div className="relative z-10 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50 border-2 border-secondary-200 flex items-center justify-center flex-shrink-0 group-hover:border-secondary-400 transition-colors">
                  <i className="ri-flashlight-line text-secondary-600 text-sm md:text-base"></i>
                </div>

                <div className="flex-1 min-w-0 pt-1 md:pt-2">
                  <div className="text-xs text-foreground-400 mb-1">{item.date}</div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}